import { render } from "./ChooseAddressCard.vue?vue&type=template&id=1ac18779&scoped=true"
import script from "./ChooseAddressCard.vue?vue&type=script&lang=ts"
export * from "./ChooseAddressCard.vue?vue&type=script&lang=ts"

import "./ChooseAddressCard.vue?vue&type=style&index=0&id=1ac18779&lang=scss"
import "./ChooseAddressCard.vue?vue&type=style&index=1&id=1ac18779&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ac18779"

export default script